import { ConversationHistory } from './ConversationHistory'
import { ConversationMenuPanel } from './ConversationMenuPanel'
import { ConversationMenuPanelOverlay } from './ConversationMenuPanelOverlay'
import { ConversationMenuPanelToggle } from './ConversationMenuPanelToggle'
import { FlowAccessLinkButton } from './FlowAccessLinkButton'
import { NewConversationButton } from './NewConversationButton'
import { NewDocumentAnalysisButton } from './NewDocumentAnalysisButton'

export const ConversationMenu = () => (
  <>
    <ConversationMenuPanelOverlay />
    <ConversationMenuPanel>
      <ConversationMenuPanelToggle />
      <NewConversationButton />
      <NewDocumentAnalysisButton />
      <FlowAccessLinkButton />
      <ConversationHistory />
    </ConversationMenuPanel>
  </>
)
